import { FC } from "react";
import { Box, Paper, Skeleton, Stack, Typography } from "@mui/material";

const EmployeeCardSkeleton: FC = () => (
  <Paper sx={{ padding: "1.5rem" }}>
    <Stack direction="row" spacing={4} alignItems="center">
      <Skeleton variant="circular" width={40} height={40} />
      <Box flexBasis="50%">
        <Typography variant="subtitle2">
          <Skeleton />
        </Typography>
        <Typography variant="body2">
          <Skeleton />
        </Typography>
        <Typography variant="body2">
          <Skeleton />
        </Typography>
      </Box>
    </Stack>
  </Paper>
);

export default EmployeeCardSkeleton;
